import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useStyles } from './styled';
import { Grid } from '@kis-technologies/kis-ui';
import { EmailDelivery } from './components/EmailDelivery';
import { PrintDelivery } from './components/PrintDelivery';
import { TextDelivery } from './components/TextDelivery';
import { useSelector } from 'react-redux';
import { selectors as ticketingSelectors, actions as ticketingActions } from 'services/ticketing';
import { selectors as cartSelectors } from 'services/cart';
import { selectors as kioskSelectors, actions as kioskActions } from 'services/kiosk';
import { useActions } from 'hooks/useActions';

const DeliveryView: React.FC = () => {
  const navigate = useNavigate();
  const { path } = useParams<{ path: string }>();

  const checkoutCart = useSelector(cartSelectors.selectCheckoutCart);
  const deliveryMethod = useSelector(ticketingSelectors.selectPreferredDeliveryMethod);
  const deliveryStatus = useSelector(ticketingSelectors.selectDeliveryStatus);
  const tickets = useSelector(kioskSelectors.selectTickets);

  const { createPrintTickets, emailTickets, sendTextTickets } = useActions({
    createPrintTickets: kioskActions.createPrintTickets,
    emailTickets: ticketingActions.emailTickets,
    sendTextTickets: ticketingActions.sendTextTickets
  });

  const classes = useStyles();

  const onCompletion = () => {
    const completionRoute = `/${path}/completion`;
    return navigate(completionRoute);
  };

  const onErrorConfirmation = () => {
    navigate('/ticketing/attract');
  };

  React.useEffect(() => {
    if (checkoutCart && !deliveryStatus) {
      const { orderId, transactionId, deliveryParams } = checkoutCart;
      const payload = { orderId, transactionId, deliveryParams };

      if (deliveryMethod === 'email') {
        emailTickets(payload);
      } else if (deliveryMethod === 'textMessage') {
        sendTextTickets(payload);
      } else {
        if (!tickets || !tickets.length) {
          createPrintTickets(payload);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getScreen = () => {
    switch (deliveryMethod) {
      case 'email':
        return (
          <EmailDelivery key={`delivery-email`} onCompletion={onCompletion} onErrorConfirmation={onErrorConfirmation} />
        );
      case 'textMessage':
        return (
          <TextDelivery key={`delivery-text`} onCompletion={onCompletion} onErrorConfirmation={onErrorConfirmation} />
        );
      default:
        return (
          <PrintDelivery key={`delivery-print`} onCompletion={onCompletion} onErrorConfirmation={onErrorConfirmation} />
        );
    }
  };

  return <Grid className={classes.deliveryComponentContainer}>{getScreen()}</Grid>;
};

export default DeliveryView;
